import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig } from '../../types'
import {
  createBaseConfig,
  createStandardTabs,
  createStandardSteps,
  createStandardTicketFlow,
  angelImagesUrl,
  staticAssetUrl,
} from '../shared'

export const getSketchConfig = (t: TranslateFunction): GiveawayConfig => {
  const squareImage = staticAssetUrl('v1750805986/sketch/sketch-key-art-img-square.webp')

  return createBaseConfig({
    theatricalSlug: slugs.sketch,
    heroTitle: t(
      'giveawayHeroTitleSketch',
      'See SKETCH in Theaters & Get Entries to the Freddie Wong Ultimate Creator Giveaway',
    ),
    logoUrl: angelImagesUrl('v1750701024/sketch/FINAL_SKETCH_LOGO_2.webp'),
    footerLogoUrl: angelImagesUrl('v1750802130/sketch/sketch-logo-white.webp'),
    footerBgImage: angelImagesUrl('v1749505430/sketch/dark-pink-bg-01.webp'),
    inTheatersText: t('inTheatersSketch', 'In theaters August 6th'),
    videoImage: angelImagesUrl('v1747868345/sketch-trailer-thumb-nr_vkmkv9.webp'),
    backgroundVideoUrl: 'https://content.angelstudios.com/sketch/SKETCH%20Trailer%20Loop.mp4',
    share: {
      shareText:
        'The upcoming @AngelStudios movie SKETCH in theaters on August 6th. Pre-order tickets for a chance to win The SKETCH & Freddie Wong Ultimate Creator Giveaway. #SKETCHGiveaway #FreddyWong',
      hashtag: '#SKETCHGiveaway',
      shareImage: angelImagesUrl('v1750805986/sketch/sketch-key-art-img-square.webp'),
      shareImageMobile: angelImagesUrl('v1750805986/sketch/sketch-key-art-img-square.webp'),
    },

    ticketFlow: createStandardTicketFlow({
      t,
      projectSlug: slugs.sketch,
      congratsKey: 'sketchCongratsModalText',
      congratsText:
        "You've earned entries for your chance to win the Freddie Wong Ultimate Creator Giveaway! Complete your checkout to secure your entries.",
      reservationKey: 'sketchReservationCompleteText',
      reservationText: "You've earned entries for your chance to win the Freddie Wong Ultimate Creator Giveaway!",
      noShowtimesKey: 'sketchNowShowtimes',
      noShowtimesText:
        "We're adding new theaters every week. While you wait, pre-order tickets today for your chance to win the Freddie Wong Ultimate Creator Giveaway.",
      landscapeImage: squareImage,
      portraitImage: squareImage,
    }),

    steps: [
      ...createStandardSteps(t),
      {
        title: t('preOrderTicketsStep3Sketch', 'Multiply Your Chances To Win'),
        description: t(
          'preOrderTicketsStep3DescriptionSketchV5',
          'Every pre-order ticket enters you to win the one (1) Grand Prize — The Freddie Wong Ultimate Creator Kit. Additionally, nine (9) winners will be selected for a three (3) day trip and masterclass at the Freddie Wong Film Lab at Rocket Jump Studios in Los Angeles, California.',
        ),
      },
    ],

    tabs: createStandardTabs(t),

    galleryImages: [
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-01.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-02.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-03.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-04.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-05.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-06.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-07.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-08.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-09.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-10.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
    ],
    partnerLogos: [
      {
        src: '/v1750962583/sketch/4b18908b39f6f2fcdefbbf070983c1b2b3242bf3.png',
        alt: 'rocket-jump-logo',
      },
    ],
  })
}
